export enum Role {
  ADMIN = 'ADMIN',
  MANAGEMENT_TEAM = 'MANAGEMENT_TEAM',
  CREATOR = 'CREATOR',
  FACTORY_WORKER = 'FACTORY_WORKER',
  COLLECTION_OPERATOR = 'COLLECTION_OPERATOR',
  PARTNER = 'PARTNER',
}
